import { UICategoryFilter, useClientSettingStore, useStoreUI } from '@assets/model/Store';
import { debounce } from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Flex } from '../../UI/Flex/Flex';
import * as style from './DealModalSearchHeader.module.less';

export const DealModalSearchHeader = observer(() => {
    const ui = useStoreUI();
    const clientStore = useClientSettingStore();
    const [multiSelectionsIndustry, setMultiSelectionsIndustry] = useState([]);
    const [textSearch, setTextSearch] = useState(ui.dealPageNameSearch);

    const setTextSearchDebounce = debounce((text: string) => {
        ui.dealPageNameSearch = text;
    }, 300);

    const updateSelectionIndustry = (selected: []) => {
        var updated = [];
        selected.forEach((selection: any) => {
            if (!updated.find((item: any) => item.value == selection.value)) {
                updated.push({
                    label: selection.label,
                    value: selection.value
                });
            }
        });
        setMultiSelectionsIndustry(updated);
    };

    // Update UI store when industry selections change
    useEffect(() => {
        const filter: UICategoryFilter[] = multiSelectionsIndustry.map(selection => {
            const [type, value] = selection.value.split(':');
            return {
                type: type === 'CAT' ? 'category' : 'sub_category',
                value: value
            };
        });
        ui.dealPageIndustrySearch = filter;
    }, [multiSelectionsIndustry]);

    const filterBy = (option, ticker) => {
        return option.label.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1;
    };

    const braileSpacing = '⠀  ';
    var options = [];
    const industry = useClientSettingStore().industryTypes;
    industry.forEach(industry => {
        var name = industry.name;
        options.push({
            label: name,
            value: 'CAT:' + name,
            industry: name,
            type: 'category'
        });
        industry.subtypes.forEach(sub_industry => {
            options.push({
                label: braileSpacing + sub_industry.name,
                value: 'SUB:' + sub_industry.name,
                industry: name,
                type: 'subcategory'
            });
        });
    });

    return (
        <Flex direction="row" className={style.searchBar}>
            <input
                type="text"
                className={style.search}
                value={textSearch}
                onInput={e => {
                    setTextSearch(e.currentTarget.value);
                    setTextSearchDebounce(e.currentTarget.value);
                }}
                placeholder="Filter by name"
            />
            <div className={style.industrySearch}>
                <Typeahead
                    id="industry-search"
                    filterBy={filterBy}
                    options={options}
                    placeholder="Filter by Industry"
                    onChange={updateSelectionIndustry}
                    selected={multiSelectionsIndustry}
                    multiple={true}
                />
            </div>
        </Flex>
    );
}); 